import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

interface DropzoneLocalization {
  drag_and_drop_or: string;
  browse_to_choose_a_file: string;
  recommended_file_types: string;
  max_file_size: string;
  invalid_file: string;
  chosen_file: string;
}

export default class Translations {
  static dropzoneLocalization = (): DropzoneLocalization => ({
    drag_and_drop_or: t('drag-and-drop-or').toString(),
    browse_to_choose_a_file: t('browse-to-choose-a-file').toString(),
    recommended_file_types: t('recommended-file-types').toString(),
    max_file_size: t('max-file-size').toString(),
    invalid_file: t('invalid-file').toString(),
    chosen_file: t('chosen-file').toString(),
  });
}
